<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <v-col cols="12" sm="6" lg="4" :class="setClass(0)">
            <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
                    <v-card-title class="pa-3">
			            <p class="pl-2 pl-xl-3">Inviate</p>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        
                        <campaign-kpi v-if="loaded"
                            name="sended"
                            category="Inviate"
                            :counter="campaign.sent"
                            :total="campaign.maillist_length"
                            :colorIndex="0"
                        ></campaign-kpi>

                        <v-divider></v-divider>
                        <v-row class="pa-0 ma-0">
                            <v-col class="text-center">
                                <span class="font-weight-light">Destinatari Invalidi: <span class="font-weight-medium">{{ campaign.invalid_recipients }}</span></span>
                            </v-col>
                            <v-divider vertical></v-divider>
                            <v-col class="text-center">
                                <span class="font-weight-light">Destinatari non processati: <span class="font-weight-medium">{{ campaign.unprocessed_recipients }}</span></span>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-hover>
        </v-col>
        <!-- <v-col cols="12" sm="6" lg="4" :class="setClass(1)">
            <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
                    <v-card-title class="pa-3">
			            <p class="pl-2 pl-xl-3">Consegnate</p>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        
                        <campaign-kpi v-if="loaded"
                            name="delivered"
                            category="Consegnate"
                            :counter="campaign.deliveres"
                            :total="campaign.sent"
                            :colorIndex="1"
                        ></campaign-kpi>

                        <v-divider></v-divider>
                        <v-row class="pa-0 ma-0">
                            <v-col class="text-center">
                                <span class="font-weight-light">Non consegnate: <span class="font-weight-medium">{{ campaign.sent - campaign.deliveres }}</span></span>
                            </v-col>
                            <v-divider vertical></v-divider>
                            <v-col class="text-center">
                                <span class="font-weight-light">Respinte: <span class="font-weight-medium">{{ campaign.bounces }}</span></span>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-hover>
        </v-col> -->
        <v-col cols="12" sm="6" lg="4" :class="setClass(1)">
            <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
                    <v-card-title class="pa-3">
			            <p class="pl-2 pl-xl-3">Aperte</p>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        
                        <p v-if="loaded && untracked" class="text-center font-weight-light ma-0 pa-6">Tracciamento non attivo</p>
                        <campaign-kpi v-else-if="loaded"
                            name="opened"
                            category="Aperte"
                            :counter="campaign.unique_opens"
                            :total="campaign.sent - (campaign.untracked_sent || 0)"
                            :colorIndex="2"
                        ></campaign-kpi>                               

                        <v-divider></v-divider>
                        <v-row class="pa-0 ma-0">
                            <v-col class="text-center">
                                <span class="font-weight-light">Aperture: <span class="font-weight-medium">{{ campaign.opens }}</span></span><br>
                            </v-col>
                            <v-divider vertical></v-divider>
                            <v-col class="text-center">
                                <span class="font-weight-light">Aperture Uniche: <span class="font-weight-medium">{{ campaign.unique_opens }}</span></span>
                            </v-col>
                            <v-divider vertical></v-divider>
                            <v-col class="text-center">
                                <span class="font-weight-light">Senza tracciamento: <span class="font-weight-medium">{{ campaign.untracked_sent || 0 }}</span></span>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-hover>
        </v-col>
        <v-col cols="12" sm="12" lg="4" :class="setClass(3)">
            <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
                    <v-card-title class="pa-3">
			            <p class="pl-2 pl-xl-3">Click</p>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        
                        <p v-if="loaded && untracked" class="text-center font-weight-light ma-0 pa-6">Tracciamento non attivo</p>
                        <campaign-kpi v-else-if="loaded"
                            name="clicked"
                            category="Click"
                            :counter="campaign.unique_clicks"
                            :total="campaign.clicks"
                            :colorIndex="3"
                        ></campaign-kpi>                               

                        <v-divider></v-divider>
                        <v-row class="pa-0 ma-0">
                            <v-col class="text-center">
                                <span class="font-weight-light">Click: <span class="font-weight-medium">{{ campaign.clicks }}</span></span><br>
                            </v-col>
                            <v-divider vertical></v-divider>
                            <v-col class="text-center">
                                <span class="font-weight-light">Click Unici: <span class="font-weight-medium">{{ campaign.unique_clicks }}</span></span>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-hover>
        </v-col>

        <campaign-analytics-recipients
            class="pr-xl-2 pr-lg-2"
            :id="id"
            title="Destinatari più attivi"
            :url="'/most-active-recipients'"
            :headers="mostActiveRecipientsHeaders"
            create-mailing-list
            create-opportunity
            tooltip="Destinatari con più interazioni (aperture e click)"
        ></campaign-analytics-recipients>

        <campaign-analytics-recipients
            class="pl-xl-2 pl-lg-2"
            :id="id"
            title="Disiscrizioni"
            :url="'/unsubscribed-recipients'"
            :headers="unsubscribedRecipientsHeaders"
            tooltip="Destinatari che si sono discritti dalla newletter e non vogliono più ricevere email"
        ></campaign-analytics-recipients>
        
        <campaign-analytics-recipients
            class="pr-xl-2 pr-lg-2"
            :id="id"
            title="Destinatari invalidi"
            :url="'/invalid-recipients'"
            :headers="invalidRecipientsHeaders"
            tooltip="Destinatari con indirizzi email non validi"
        ></campaign-analytics-recipients>
        
        <campaign-analytics-recipients
            class="pl-xl-2 pl-lg-2"
            :id="id"
            title="Destinatari non processati"
            :url="'/unprocessed-recipients'"
            :headers="unprocessedRecipientsHeaders"
            tooltip="Destinatari con indirizzi email non presenti"
        ></campaign-analytics-recipients>
        
        <campaign-analytics-recipients
            class="pr-xl-2 pr-lg-2"
            :id="id"
            title="Destinatari non raggiunti"
            :url="'/undelivered-recipients'"
            :headers="undeliveredRecipientsHeaders"
            deleteRecipients
            tooltip="Destinatari a cui non viene consegnate le email"
        ></campaign-analytics-recipients>
        
        <campaign-analytics-recipients
            class="pl-xl-2 pl-lg-2"
            :id="id"
            title="Destinatari respinti"
            :url="'/bounced-recipients'"
            :headers="bouncedRecipientsHeaders"
            deleteRecipients
            tooltip="Destinatari che hanno respinto la mail inviata"
        ></campaign-analytics-recipients>
        
    
        <v-col cols="12" class="pa-0 pt-4">
            <campaign-links
                :id="id"
            ></campaign-links>
        </v-col>
    </v-row>
</template>

<script>

    import CampaignKpi from '@/components/modules/mailmarketing/CampaignKpi'
    import CampaignLinks from '@/components/modules/mailmarketing/CampaignLinks'
    import CampaignAnalyticsRecipients from '@/components/modules/mailmarketing/CampaignAnalyticsRecipients'

    export default {
        name: 'campaign-analytics',
        components: {
            CampaignKpi,
            CampaignLinks,
            CampaignAnalyticsRecipients
        },

        props: {
            id: Number,
        },

        data() {
            return {
                campaign: {},
                loaded: false,
                mostActiveRecipients: [],
                mostActiveRecipientsHeaders: [
                    {
                        text: 'Anagrafica',
                        value: 'company'
                    },
                    {
                        text: 'Contatto',
                        value: 'contact'
                    },
                    {
                        text: 'Email',
                        value: 'email'
                    },
                    {
                        text: 'Click',
                        value: 'clicks'
                    },
                    {
                        text: 'Aperture',
                        value: 'opens'
                    },
                    {
                        text: 'Ultima Interazione',
                        value: 'updated_at',
                        type: 'date'
                    },
                ],
                unsubscribedRecipients: [],
                unsubscribedRecipientsHeaders: [
                {
                    text: 'Anagrafica',
                    value: 'company'
                },
                {
                    text: 'Contatto',
                    value: 'contact'
                },
                {
                    text: 'Email',
                    value: 'email'
                },
                {
                    text: 'Data disiscrizione',
                    value: 'updated_at',
                    type: 'date'
                },
                ],
                invalidRecipients: [],
                invalidRecipientsHeaders: [
                    {
                        text: 'Anagrafica',
                        value: 'company'
                    },
                    {
                        text: 'Contatto',
                        value: 'contact'
                    },                    
                    {
                        text: 'Email',
                        value: 'email'
                    },
                ],
                unprocessedRecipients: [],
                unprocessedRecipientsHeaders: [
                    {
                        text: 'Anagrafica',
                        value: 'company'
                    },
                    {
                        text: 'Contatto',
                        value: 'contact'
                    },                    
                    {
                        text: 'Email',
                        value: 'email'
                    },
                ],
                undeliveredRecipients: [],
                undeliveredRecipientsHeaders: [
                    {
                        text: 'Anagrafica',
                        value: 'company'
                    },
                    {
                        text: 'Contatto',
                        value: 'contact'
                    },                    
                    {
                        text: 'Email',
                        value: 'email'
                    },
                ],
                bouncedRecipients: [],
                bouncedRecipientsHeaders: [
                    {
                        text: 'Anagrafica',
                        value: 'company'
                    },
                    {
                        text: 'Contatto',
                        value: 'contact'
                    },                    
                    {
                        text: 'Email',
                        value: 'email'
                    },
                ],
            }
        },

        computed: {
            // Nessun inviato tracciato (tracciamento spento o negato da tutti): "0 (0%)"
            // vorrebbe dire che nessuno l'ha aperta
            untracked() {
                return this.campaign.sent > 0 && (this.campaign.untracked_sent || 0) >= this.campaign.sent
            }
        },

        methods: {

            initialize() {
                this.axios.get('emailcampaigns-stats/' + this.id).then(response => {
                    this.campaign = response.data.data.model

                    this.$store.commit('endProgress')
                    this.loaded = true

                }, response => {
                    // error callback
                })
            },

            setClass(i) {
                if(this.$vuetify.breakpoint.xl) {
                    if(i == 0) {
                        return 'pa-0 pl-0 pr-2'
                    } else if(i == 3) {
                        return 'pa-0 pl-2'
                    } else {
                        return 'pa-0 pr-2 pl-2'
                    }
                }
                if(this.$vuetify.breakpoint.lg) {
                    if(i == 0) {
                        return 'pa-0 pl-0 pr-2'
                    } else if(i == 3) {
                        return 'pa-0 pl-2'
                    } else {
                        return 'pa-0 pr-2 pl-2'
                    }
                }
                if(this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md){
                    if(i == 0) {
                        return 'pa-0 pl-0 pr-2'
                    } else if(i == 2) {
                        return 'pa-0 pl-0 pr-2 pt-4'
                    } else if(i == 3) {
                        return 'pa-0 pl-2 pr-0 pt-4'
                    } else {
                        return 'pa-0 pl-2 pr-0'
                    }                    
                }
                if(this.$vuetify.breakpoint.xs) {
                    if(i == 0) {
                        return 'pa-0 pl-0 pr-0'
                    }
                    return 'pa-0 pl-0 pr-0 pt-4'
                }
            },
        },

        created() {
            this.initialize()
        },

    }
</script>

<style>

</style>